var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 122.88 120.57",
    style: {
      enableBackground: "new 0 0 122.88 120.57"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, ".st0{fill:#E26B1B;} .st1{fill:#FEEACE;} .st2{fill:#FEA832;} .st3{fill:#FEA832;stroke:#FEA832;stroke-width:0.216;stroke-miterlimit:2.6131;}")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M91.31,7.56c12.44,7.55,22.76,20.2,28.02,36.17c5.26,15.97,4.48,32.29-1.04,45.74 c-5.57,13.58-15.95,24.26-29.82,28.83c-9.04,2.98-32.08,2.79-42.29,0.77C19.88,113.87,0,89.83,0,60.97 C0,14.88,54.64-14.7,91.31,7.56L91.31,7.56L91.31,7.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M88.86,11.61C77.48,4.7,64.19,2.48,51.69,6.6C39.2,10.71,29.82,20.39,24.77,32.72 c-5.09,12.42-5.81,27.52-0.94,42.37c0.02,0.06,0.04,0.11,0.06,0.17c4.91,14.84,14.45,26.56,25.93,33.53 c11.39,6.91,24.68,9.13,37.17,5.01c12.49-4.11,21.87-13.79,26.92-26.12c5.1-12.45,5.81-27.58,0.91-42.46 C109.92,30.35,100.36,18.59,88.86,11.61L88.86,11.61L88.86,11.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M72.34,64.34c0.06-0.04,0.12-0.08,0.19-0.11c0.1-0.05,0.2-0.1,0.3-0.14c0.32-0.2,0.61-0.43,0.87-0.69 c0.86-0.87,1.39-2.09,1.39-3.43c0-1.34-0.53-2.57-1.39-3.43c-0.69-0.71-1.61-1.2-2.65-1.34c-0.14,0-0.28-0.02-0.41-0.04 c-0.09,0-0.18-0.01-0.27-0.01c-1.29,0-2.45,0.53-3.3,1.38c-0.06,0.08-0.12,0.17-0.2,0.24c-0.04,0.04-0.08,0.08-0.12,0.12 c-0.68,0.84-1.09,1.91-1.09,3.1c0,1.35,0.53,2.57,1.39,3.43c0.85,0.86,2.03,1.4,3.32,1.4C71.08,64.77,71.74,64.62,72.34,64.34 L72.34,64.34L72.34,64.34z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65.18,51.73c1.04-0.68,2.22-1.16,3.5-1.39l0.55-31.22c-1.67-1.7-3.82-2.66-6.18-3.01 c-2.42-0.36-5.05-0.07-7.62,0.74c-2.63,0.84-5.17,2.2-7.32,4c-2.83,2.36-5.02,5.45-5.89,9.01L65.18,51.73L65.18,51.73L65.18,51.73z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M60.75,60.19c0-0.08,0-0.17,0-0.25c0-1.65,0.41-3.22,1.14-4.59L39.7,34.23c-4.27,4.8-7.05,9.86-7.79,15.28 c-0.74,5.53,0.62,11.57,4.72,18.26L60.75,60.19L60.75,60.19L60.75,60.19z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M65.17,68.14c-0.59-0.38-1.13-0.83-1.61-1.32c-0.56-0.57-1.06-1.21-1.46-1.9l-23.75,7.46 c0.52,7,2.36,12.46,5.64,16.25c3.12,3.6,7.66,5.75,13.73,6.35L65.17,68.14L65.17,68.14L65.17,68.14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M72.68,69.41c-0.74,0.19-1.52,0.29-2.32,0.29c-0.19,0-0.36-0.01-0.54-0.01l-7.66,27.56 c1.89,2.62,4.63,4.51,7.66,5.6c2.41,0.87,5.02,1.23,7.55,1.07c2.46-0.17,4.83-0.84,6.84-2.06c1.83-1.11,3.37-2.67,4.42-4.71 L72.68,69.41L72.68,69.41L72.68,69.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M79.98,60.77c-0.2,2.35-1.22,4.47-2.78,6.05c-0.07,0.07-0.14,0.14-0.23,0.22l15.26,26.51 c5.83-2.71,9.76-6.39,11.74-11.46c2.09-5.37,2.1-12.42-0.03-21.66L79.98,60.77L79.98,60.77L79.98,60.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M78.05,54.06c0.42,0.56,0.79,1.17,1.08,1.82l24.77-0.35c0.99-5.26,0.37-10.19-1.54-14.22 c-1.87-3.94-5-7.04-9.05-8.78L78.05,54.06L78.05,54.06L78.05,54.06z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M73.57,50.75c0.22,0.08,0.43,0.17,0.64,0.26L89.7,29.15c-1.54-4.86-3.71-7.79-6.4-9.12 c-2.49-1.24-5.6-1.19-9.19-0.09L73.57,50.75L73.57,50.75L73.57,50.75z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrange);
export default __webpack_public_path__ + "static/media/orange.5a42516af12030fd703b7b3e391dd208.svg";
export { ForwardRef as ReactComponent };